type Listener = (value: boolean) => void;

let required = true;
const listeners = new Set<Listener>();

export const setAppIntegrityRequired = (value: boolean): void => {
  if (required === value) return;
  required = value;
  listeners.forEach((listener) => listener(value));
};

export const isAppIntegrityRequired = (): boolean => required;

export const subscribeAppIntegrityRequired = (
  listener: Listener
): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
